import { render, staticRenderFns } from "./searchbox.vue?vue&type=template&id=16b5fa37"
import script from "./searchbox.vue?vue&type=script&lang=ts"
export * from "./searchbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports